export const textWithGradient = (text) => {
  const regex = /<gradient>(.*?)<\/gradient>/g;
  return text.replace(regex, '<span class="gradient">$1</span>');
};
